<!--  -->
<template>
  <div :class="['couppon_card_box', { inApp: $root.$data.isApp }]">
    <common-title
      titleName="优惠券"
      :bcColor="'#FEFEFF'"
      :zIndex="1000"
    ></common-title>
    <div v-show="!couponList.length">
      <div class="defaultImg">
        <img
          src="@/pages/personalCenter/myCoupon/img/couponDefault.png"
          alt
        />
        <p>还没有优惠券喔～</p>
      </div>
    </div>
    <ul>
      <li
        v-for="(item, index) in couponList"
        :key="index"
      >
        <CouponsCard
          :couponInfo="item"
          class="couppon_card"
        >
          <div class="slot">
            <div
              v
              class="btn"
              @click="receiveCoupon(item, index)"
              v-if="!item.alreadyGet"
            >
              立即领取
            </div>
            <div
              class="btn active"
              v-else
              @click="toUse(item)"
            >立即使用</div>
          </div>
        </CouponsCard>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import CouponsCard from '@/components/coupon/CouponsCard.vue';
// eslint-disable-next-line import/no-cycle
import { reqReceiveCoupon } from '@/api/coupon/index';
// eslint-disable-next-line import/no-cycle
import { reqCouponList } from '@/api/newUser/index';
import { setBaseUrl } from '@/utils/tools';
import CommonTitle from '@/components/header/CommonTitle.vue';

export default {
  components: {
    CouponsCard,
    CommonTitle,
  },
  data() {
    return {
      couponList: [],
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {},
  methods: {
    async getCoupon() {
      const couponIds = this.$route.query?.couponIds?.split(',');
      if (!couponIds[0]) return;
      const ids = `couponId=${couponIds?.map((item) => item).join('&couponId=')}`;
      const { data } = await reqCouponList(ids);
      this.couponList = data || [];
      this.couponList.forEach((element) => {
        let dateTimeInfo = null;
        if (element.effectiveTimeType === 1) {
          dateTimeInfo = `领取后${element.effectiveDays}天内有效`;
        } else if(element.effectiveTimeType === 2) {
          dateTimeInfo = `${element.effectiveTimeBegin
            .slice(0, 11)
            .replace(/-/g, '.')}-${element.effectiveTimeEnd.slice(0, 11).replace(/-/g, '.')}`;
        } else if(element.effectiveTimeType === 3) {
          dateTimeInfo = '领取后当天有效'
        } else if(element.effectiveTimeType === 4) {
          dateTimeInfo = `领取后${element.effectiveHours}小时内有效`
        }
        Object.assign(element, { dateTimeInfo, couponName: element.frontEndName });
      });
    },
    async receiveCoupon(item, index) {
      if (!this.userInfo.id) {
        const { isApp = false } = this.$root.$data;
        if (isApp) {
          this.$sendToApp('login');
        } else {
          const param = { redirect: '/coupons', ...this.$route.query };
          this.$router.push({ path: '/registrationLogin', query: param });
        }
        return;
      }
      const res = await reqReceiveCoupon({
        couponId: String(item.couponId),
        couponVersion: Number(item.couponVersion),
        isLink: 0,
        fitPlatform: 1,
        fitEndPoint: this.$root.$data.isApp ? 2 : 4,
        terminalMark: this.$global.terminalMark
      });
      if (res.code === 0) {
        this.$toast('领取成功');
        Object.assign(item, { alreadyGet: 1 });
        this.$set(this.couponList, index, item);
      } else {
        this.$toast(res.msg);
      }
    },
    toUse(item) {
      const { productionFitType,packageFitType } = item;
      let routeUrl = '';
      // 适用产品类型 1 所有产品 2 限定产品 3 限定产品分类 4 所有套餐 5 限定套餐
      if (productionFitType === 1 || productionFitType === 4||packageFitType==4) {
        // 判断是否App
        if (this.$root.$data.isApp) {
          this.$sendToApp('goToHomePage');
          return;
        }
        this.$router.push({
          path: '/home',
          query: {
            code: 2,
          },
        });
        return;
      }
      if(packageFitType===5&&(productionFitType===2||productionFitType===3)){
         const { productIds ,productCatalogIds,packageIds} = item;
         const productId = productIds?.join();
         const productCategoryId = productCatalogIds?.join();
         const packageId = packageIds?.join();
        if (this.$root.$data.isApp) {
            this.$sendToApp(
              'openNewWebView',
              { url: `${setBaseUrl('')}/ark/limitProduct?productionFitType=${productionFitType}&packageFitType=${packageFitType}&productIds=${productId}&productCategoryIds=${productCategoryId}` },
              false,
            );
            return;
          }
          routeUrl = this.$router.resolve({
            path: '/limitProduct',
            query: {
              productionFitType,
              packageFitType,
              productIds:productId,
              productCategoryIds:productCategoryId,
              packageIds:packageId,
            },
          });
          window.open(routeUrl.href, '_blank');
        return
      }
      if (productionFitType === 2) {
        const { productIds } = item;
        if (productIds.length > 1) {
          const productId = productIds.join();
          if (this.$root.$data.isApp) {
            this.$sendToApp(
              'openNewWebView',
              { url: `${setBaseUrl('')}/ark/productList?type=5&productId=${productId}` },
              false,
            );
            return;
          }
          routeUrl = this.$router.resolve({
            path: '/productList',
            query: {
              type: 5,
              productId,
            },
          });
        } else {
          // 判断是否App
          if (this.$root.$data.isApp) {
            this.$sendToApp('goCourseDetail', Number(productIds[0]), false);
            return;
          }
          routeUrl = this.$router.resolve({
            path: '/courseDetail',
            query: {
              courseId: productIds[0],
            },
          });
        }
        window.open(routeUrl.href, '_blank');
        return;
      }
      if (productionFitType === 3) {
        const { productCatalogIds } = item;
        const productCategoryId = productCatalogIds.join();
        if (this.$root.$data.isApp) {
          this.$sendToApp(
            'openNewWebView',
            {
              url: `${setBaseUrl(
                '',
              )}/ark/productList?type=3&productCategoryId=${productCategoryId}`,
            },
            false,
          );
          return;
        }
        routeUrl = this.$router.resolve({
          path: '/productList',
          query: {
            type: 3,
            productCategoryId,
          },
        });
        window.open(routeUrl.href, '_blank');
        return;
      }
      if (productionFitType === 5||packageFitType===5) {
        const { packageIds } = item;
        if (packageIds.length > 1) {
          const packageId = packageIds.join();
          if (this.$root.$data.isApp) {
            this.$sendToApp(
              'openNewWebView',
              { url: `${setBaseUrl('')}/ark/combinationList?packageIds=${packageId}` },
              false,
            );
            return;
          }
          routeUrl = this.$router.resolve({
            path: '/combinationList',
            query: {
              packageIds: packageId,
            },
          });
          window.open(routeUrl.href, '_blank');
        } else {
          // 判断是否App
          if (this.$root.$data.isApp) {
            this.$sendToApp('goToCombinationCourse', Number(packageIds[0]), false);
            return;
          }
          routeUrl = this.$router.resolve({
            path: '/combinationCourse',
            query: {
              combinationId: packageIds[0],
            },
          });
          window.open(routeUrl.href, '_blank');
        }
      }
    },
    async getLoginAfter() {
      await this.$root.getUserInfo();
      this.getCoupon();
    },
    getLogin(APPSESSION) {
      const ua = navigator.userAgent.toLowerCase();
      const cookieToken = /ohos/.test(ua) ? APPSESSION.token : APPSESSION;
      if ((window?.navigator?.userAgent || '').includes('iqihang')) {
        window.localStorage.setItem('accessToken', cookieToken || '');
        this.getLoginAfter();
      }
    },
  },
  created() {
    this.getCoupon();
  },
  mounted() {
    window['iqhApp2jsBridge.triggerSC'] = {};
    // 获取登录状态
    window['iqhApp2jsBridge.triggerSC'].getLogin = this.getLogin;
  },
};
</script>
<style lang="scss" scoped>
.couppon_card_box {
  padding-top: 100px;
  &.inApp {
    padding-top: 30px;
  }
  ul {
    padding: 30px;
    li {
      background: #fff;
      border-radius: 18px;
    }
    .couppon_card {
      position: relative;
      margin-bottom: 30px;
      .isRecommend {
        position: absolute;
        top: 0;
        right: 0;
        width: 58px;
        height: 33px;
        color: #fff;
        font-size: 22px;
        line-height: 33px;
        text-align: center;
        background: #ff6c02;
        border-radius: 0 5px 0 5px;
      }
      .slot {
        // position: absolute;
        // bottom: 0;
        z-index: 100;
        margin-top: 5px;
        text-align: center;
        .btn {
          display: inline-block;
          width: 129px;
          color: #fff;
          font-weight: 500;
          font-size: 22px;
          line-height: 51px;
          text-align: center;
          background: #ff7f41;
          border-radius: 25px;
        }
        .btn.active {
          color: #fff;
          background: #ff6c02;
        }
        img {
          width: 116px;
        }
      }
    }
  }
  .defaultImg {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 290px;
    margin: 0 auto;
    img {
      display: block;
      width: 290px;
      height: 290px;
    }
    p {
      color: #787878;
      font-size: 25px;
      line-height: 36px;
    }
  }
}
</style>
